import { Tile } from '@thro-types/users';

export function isInSelectedTilesArray(tile: Tile, selectedTilesArray: Tile[]) {
  return selectedTilesArray.find(sTile => sTile.id === tile.id);
}
